import { render, staticRenderFns } from "./upload_success_kyc.vue?vue&type=template&id=aa91e4e8&scoped=true"
import script from "./upload_success_kyc.vue?vue&type=script&lang=js"
export * from "./upload_success_kyc.vue?vue&type=script&lang=js"
import style0 from "./upload_success_kyc.vue?vue&type=style&index=0&id=aa91e4e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa91e4e8",
  null
  
)

export default component.exports